<div class="col col-lg-3 mx-auto">
    <div class="row g-0 my-1">
        <h1 class="text-center">Order Confirmed</h1>
    </div>
    <div class="row g-0 my-1">
        <span class="text-center font-size-16">Thank you for your order. Please check your email inbox.</span>
    </div>
</div>